import axios from "axios";
const state = {};
import config from "@/../config";
const defaultErrorHandler = error => Promise.reject(error.response);

const mutations = {};

const actions = {
    async TOGGLE_BLOCKED_USER({
        commit
    }, payload) {
        let response = await axios.post(config.apiUrl + config.versoes[0] + "/users/block/" + payload.userId, {company_id: payload.companyId});
        return response.data;
    },
    async TOGGLE_BLOCKED_CONTACT({
        commit
    }, payload) {
        let response = await axios.post(config.apiUrl + config.versoes[0] + "/users/block-contact", {
            company_id: payload.companyId,
            email: payload.email
        });
        return response.data;
    },

    async UPDATE_CONTACT({
        commit
    }, payload) {
        delete payload.document;
        let response = await axios.patch(config.apiUrl + config.versoes[0] + "/contato/" + payload.id + "/", payload);
        return response.data;
    },
    async INSERT_CONTACT({
        commit
    }, payload) {
        delete payload.document;
        let response = await axios.post(config.apiUrl + config.versoes[0] + "/contato", payload);

        return response.data;
    },
    async DELETE_CONTACT({
        commit
    }, payload) {
        let response = await axios.delete(config.apiUrl + config.versoes[0] + "/contato/" + payload + "/", payload);
        return response.data;
    },
    async GET_CONTACTS({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[0] + "/contato?broker_id=" + payload.id);
        return response.data;
    },
    async UPDATE_BANK_INFORMATION({
        commit
    }, payload) {
        console.log(payload);
        let data = {
            numero_conta: payload.corretor.informacao_bancaria.conta,
            banco: payload.corretor.informacao_bancaria.banco,
            agencia: payload.corretor.informacao_bancaria.agencia,
            nome_responsavel: payload.corretor.informacao_bancaria.nome_responsavel,
            cpf_responsavel: payload.corretor.informacao_bancaria.cpf_responsavel,
            email_responsavel: payload.corretor.informacao_bancaria.email_responsavel,
            telefone_responsavel: payload.corretor.informacao_bancaria.telefone_responsavel,
        };
        let response = await axios.patch(config.apiUrl + config.versoes[0] + "/corretor/informacoes-bancarias", data);
        return response.data;
    },
    async CHECK_DOCUMENT({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[0] + "/corretor?documento=" + payload.document);
        return response.data;
    },
    async CHECK_DOCUMENTV2({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[1] + "/corretores/" + payload.document);
        return response.data;
    },
    async GET_BANK({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[1] + "/bancos/");
        return response.data;
    },
    async GET_CATEGORIAS_PEP({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[1] + "/peps/categorias/");
        return response.data;
    },
    async INSERT_CORRETOR({
        commit
    }, payload) {
        let response = await axios.post(config.apiUrl + config.versoes[1] + "/corretores/", payload);

        return response.data;
    },
    ME_INFO({
        commit
    }, payload) {
        return axios.get(config.apiUrl + config.versoes[0] + "/usuarios/eu/").then(response => {
            store.commit("SET_ME", response.data);
            return response.data;
        }).catch(error => {
            return Promise.reject(error.response);
        });
    },

    async GET_PROFILE_ME({
        commit
    }, payload) {
        let fromNeurotechUrl = "";
        if (payload.fromNeurotech) {
            fromNeurotechUrl = "?refresh=true";
        }
        let response = await axios.get(config.apiUrl + config.versoes[0] + "/perfil/" + fromNeurotechUrl);
        return response.data;
    },

    async GET_FAQ({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[1] + "/faq/");

        return response.data;
    }

};

export default {state, mutations, actions};



// WEBPACK FOOTER //
// ./src/store/modules/broker.js